import { S } from "../theme";

function Sidebar({ active, setActive, user, onLogout, mobileOpen, setMobileOpen, theme, toggleTheme }) {
  const items = [
    { id: "dashboard", icon: "🏠", label: "Dashboard" },
    { id: "protocol", icon: "📋", label: "My Protocol" },
    { id: "track", icon: "✅", label: "Track Today" },
    { id: "biomarkers", icon: "📊", label: "Biomarkers" },
    { id: "injections", icon: "🎯", label: "Injection Sites" },
    { id: "inventory", icon: "📦", label: "Inventory" },
    { id: "library", icon: "🔬", label: "Peptide Library" },
    { id: "ai", icon: "🤖", label: "AI Guidance" },
    { id: "community", icon: "💬", label: "Community", hidden: true },
    { id: "blog", icon: "📖", label: "Blog & Education" },
    { id: "fda", icon: "⚖️", label: "FDA Updates" },
    { id: "pricing", icon: "⭐", label: "Plans & Pricing" },
    { id: "settings", icon: "⚙️", label: "Settings" },
    { id: "disclaimer", icon: "⚕️", label: "Medical Disclaimer" },
    { id: "terms", icon: "📄", label: "Terms" },
    { id: "privacy", icon: "🔒", label: "Privacy" },
  ];

  function handleClick(id) {
    setActive(id);
    if (setMobileOpen) setMobileOpen(false);
  }

  return (
    <>
      {/* Backdrop for mobile */}
      <div className="tmp-mobile-backdrop" onClick={() => setMobileOpen(false)} style={{ display: mobileOpen ? "block" : "none", position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 50 }} />

      <div className="tmp-sidebar" style={{ background: S.darkPanel, display: "flex", flexDirection: "column", padding: "24px 16px", flexShrink: 0 }}>
        <div onClick={() => handleClick("dashboard")} style={{ padding: "8px 12px", marginBottom: 24, cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontFamily: "'Fraunces', serif", fontWeight: 900, fontSize: "1.1rem", color: "#fff", letterSpacing: "-0.02em" }}>
            Track<span style={{ color: S.accent }}>My</span>Peptide
          </span>
          <button className="tmp-sidebar-close" onClick={(e) => { e.stopPropagation(); setMobileOpen(false); }} style={{ background: "none", border: "none", color: "#fff", fontSize: "1.4rem", cursor: "pointer", padding: 4 }}>✕</button>
        </div>

        <nav style={{ flex: 1, overflowY: "auto" }}>
          {items.filter(item => !item.hidden).map(item => (
            <button key={item.id} onClick={() => handleClick(item.id)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderRadius: 12, border: "none", cursor: "pointer", marginBottom: 4, fontFamily: "'Inter', sans-serif", fontWeight: 500, fontSize: "0.88rem", transition: "all 0.15s", background: active === item.id ? "rgba(45,106,79,0.25)" : "transparent", color: active === item.id ? "#fff" : "rgba(255,255,255,0.5)", borderLeft: active === item.id ? `3px solid ${S.accent}` : "3px solid transparent", textAlign: "left" }}>
              <span style={{ fontSize: "1rem" }}>{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>

        <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: 16, marginTop: 16 }}>
          <div style={{ padding: "8px 14px", marginBottom: 8, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: "0.82rem", fontWeight: 600, color: "#fff", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.name}</div>
              <div style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.4)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.email}</div>
            </div>
            {toggleTheme && (
              <button
                onClick={toggleTheme}
                title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
                aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
                style={{ flexShrink: 0, width: 34, height: 34, borderRadius: 10, border: "1px solid rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.06)", color: "#fff", cursor: "pointer", fontSize: "1rem", lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                {theme === "dark" ? "☀️" : "🌙"}
              </button>
            )}
          </div>
          <button onClick={onLogout} style={{ width: "100%", padding: "9px 14px", borderRadius: 10, border: "none", cursor: "pointer", fontFamily: "'Inter', sans-serif", fontSize: "0.82rem", color: "rgba(255,255,255,0.4)", background: "transparent", textAlign: "left", transition: "all 0.2s" }}>
            → Log Out
          </button>
        </div>
      </div>
    </>
  );
}

export { Sidebar };
